import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

import styles from "./Navigation.css";

class SearchWindow extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      search: null,
    };

    this.handleSubmit = this._handleSubmit.bind(this);
    this.handleChange = this._handleChange.bind(this);
  }

  _handleSubmit(event) {
    event.preventDefault();

    this.props.history.push({
      pathname: "/results",
      search: `?q=${this.state.search}`,
    });
  }

  _handleChange(e) {
    this.setState({
      search: e.target.value,
    });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} className="gtm-nav-search">
        <div
          role="search"
          className={classNames(
            styles.searchWindow,
            this.props.isCompressed ? styles.mobileSearchWindow : null
          )}
        >
          <input
            ref={input => {
              if (input) input.focus();
            }}
            onChange={this.handleChange}
            aria-label="Search Axios"
            className={styles.bottomLineInputs}
            placeholder="Search Axios"
          />
        </div>
      </form>
    );
  }
}

export default withRouter(SearchWindow);
